const initState = {
    errorData: {
        error: null,
        isOpen: false,
    },
    showShimmer: false,
};
export const JWT_TOKEN_NEST_TRADER_ERROR = "JWT_TOKEN_NEST_TRADER_ERROR";
export const JWT_TOKEN_NEST_TRADER_SHIMMER = "JWT_TOKEN_NEST_TRADER_SHIMMER";
export const JWT_TOKEN_NEST_TRADER_HIDE_ERROR = "JWT_TOKEN_NEST_TRADER_HIDE_ERROR";
export var JwtTokenErrorEnum;
(function (JwtTokenErrorEnum) {
    JwtTokenErrorEnum["ERROR_DATA"] = "errorData";
})(JwtTokenErrorEnum || (JwtTokenErrorEnum = {}));
const jwtTokenNestTraderReducer = (state = initState, action) => {
    switch (action.type) {
        case JWT_TOKEN_NEST_TRADER_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: action.payload.errorData });
        case JWT_TOKEN_NEST_TRADER_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: initState[action.errorType] });
        case JWT_TOKEN_NEST_TRADER_SHIMMER:
            return Object.assign(Object.assign({}, state), { showShimmer: action.payload.showShimmer });
        default:
            return Object.assign({}, state);
    }
};
export default jwtTokenNestTraderReducer;
